import { Button, Modal } from "react-bootstrap";
import Header from "../../components/header/Header";
import ClientsForm from "./clients-form/clients-form";
import "./style.css";
import {
  formResetService,
  formService,
  getConfirmationModal,
  getData,
  removeLastData,
  setBtnEmmit,
} from "./clients-form/clients-form-service";
import "./clients-main.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import amc_black_logo from "../../../../../assets/imgs/amc-domestico/Logo_AMC_Negro.png";

function ClientsMain() {
  const [statusConfirmationModal, setStatusConfirmationModal] = useState(false);
  const [statusSpinnerModal, setStatusSpinnerModal] = useState(false);
  const [statusLabelsModal, setStatusLabelsModal] = useState({
    status: false,
    modal: "",
  });
  const [labelsArr, setLabelsArr] = useState([]);
  const [turn, setTurn] = useState({});
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  //Subscriptions
  useEffect(() => {
    const subscription = getConfirmationModal().subscribe((value) => {
      setStatusConfirmationModal(value);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const hideButton = () => {
      const button = document.querySelector('#nebula_div_btn');
      if (button) {
        button.style.display = 'none';
      }
    };

    hideButton();

    const interval = setInterval(() => {
      const button = document.querySelector('#nebula_div_btn');
      if (button) {
        button.style.display = 'none';
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];
      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();
      return `${dayName}, ${day} de ${monthName} ${year}`;
    }
    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");
      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }
    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(statusLabelsModal.modal === "label") {
      if (labelsArr.length > 0 && turn !== null) {
        printContent("label-content", "6in 4in");
      }
    }
  }, [labelsArr, turn, statusLabelsModal]);

  const handleSendData = () => {
    setBtnEmmit();
    formService.triggerSubmit();
  };

  const setDate = async () => {
    const fecha = new Date();
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();
    const horas = String(fecha.getHours()).padStart(2, "0");
    const minutos = String(fecha.getMinutes()).padStart(2, "0");
    const segundos = String(fecha.getSeconds()).padStart(2, "0");

    const fechaFormateada = `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;

    return fechaFormateada;
  }

  const handleConfirm = async () => {
    formResetService.resetForm();
    const dateFormat = await setDate();
    const body = {
      shipments: getData(),
      user_id: `${localStorage.getItem("light-load-email")}`,
      date: dateFormat
    };

    setStatusConfirmationModal(false);
    setStatusSpinnerModal(true);
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/shipment`;
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });
      setLabelsArr(response.data.data.labels);
      setTurn(response.data.data.turn);
      setStatusLabelsModal({ status: true, modal: "label" });
    } catch (error) {
      console.error(error);
      setStatusSpinnerModal(true);
      Swal.fire({
        title: "Error",
        text: "Error al capturar, por favor intentalo de nuevo",
        icon: "error",
      });
    }
  };

  const printContent = async (elementId, size, onPrintClose) => {
    const element = document.getElementById(elementId);

    if (element) {
      const printWindow = window.open("", "_blank");

      if (!printWindow) {
        console.error("No se pudo abrir la ventana de impresión. Asegúrate de que las ventanas emergentes no están bloqueadas.");
        return;
      }

      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules || [])
              .map((rule) => rule.cssText)
              .join("\n");
          } catch (err) {
            return "";
          }
        })
        .join("\n");

      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Imprimir</title>
            <style>
              ${styles}
              @page { size: ${size}; margin: 0; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${element.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();

      const checkClosed = setInterval(() => {
        if (printWindow.closed) {
          clearInterval(checkClosed);
          if(statusLabelsModal.modal === "label") {
            setStatusLabelsModal({ status: false, modal: "" });
            window.location.reload();
          }
          if (onPrintClose) onPrintClose();
        }
      }, 500);
    } else {
      console.error("Elemento no encontrado:", elementId);
    }
  };

  const handleClose = () => {
    setStatusLabelsModal({ status: false, modal: "" })
    window.location.reload();
  }

  const shipmentNumber = (index) => {
    const tagNumberArr = labelsArr.map(item => item.tag_number);
    let mapping = {};
    let counter = 1;
    const result = tagNumberArr.map(tag => {
      if (!(tag in mapping)) {
          mapping[tag] = counter++;
      }
      return mapping[tag];
    });
    return result[index]; 
  }

  const renderConfirmationModal = () => {
    return (
      <Modal
        show={statusConfirmationModal}
        onHide={() => {
          setStatusConfirmationModal(false);
          removeLastData();
        }}
        className="custom-modal-confirm"
      >
        <Modal.Body className="text-center">
          <div className="modal-icon">
            <svg
              width="139"
              height="129"
              viewBox="0 0 139 129"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.5429 24.3527C67.9325 28.8887 73.3255 35.7744 75.7294 43.7421C78.1333 51.7098 77.3863 60.2234 73.6257 67.7157C80.3401 72.5623 88.5134 75.3015 96.9837 75.544C105.454 75.7864 113.79 73.5197 120.808 69.0662C127.825 64.6126 133.166 58.1988 136.072 50.7364C138.978 43.2741 139.301 35.1429 136.995 27.4986C134.688 19.8544 129.87 13.0862 123.225 8.15608C116.581 3.22593 108.447 0.384739 99.981 0.0363606C91.5149 -0.312018 83.1471 1.85015 76.067 6.21552C68.9869 10.5809 63.5548 16.9273 60.5429 24.3527ZM98.2305 34.2871C101.66 34.2871 104.444 36.8966 104.444 40.1117V56.8307C104.444 58.3755 103.789 59.857 102.624 60.9493C101.459 62.0417 99.8784 62.6553 98.2305 62.6553C96.5826 62.6553 95.0023 62.0417 93.837 60.9493C92.6718 59.857 92.0172 58.3755 92.0172 56.8307V40.1117C92.0172 36.8966 94.8008 34.2871 98.2305 34.2871ZM90.9435 19.5625C90.9435 23.9519 94.8206 25.881 97.5545 26.1606L98.2504 26.1979C100.964 26.1979 105.547 24.334 105.547 19.5625C105.547 15.1638 101.67 13.2346 98.9364 12.9551L98.2405 12.9178C95.5265 12.9178 90.9435 14.7817 90.9435 19.5625ZM40.4116 75.8329C43.6378 75.8942 46.8445 75.3514 49.8441 74.2364C52.8436 73.1213 55.5757 71.4565 57.8804 69.3393C60.1851 67.2222 62.0159 64.6952 63.2659 61.9065C64.5158 59.1177 65.1596 56.1232 65.1596 53.0983C65.1596 50.0734 64.5158 47.0789 63.2659 44.2901C62.0159 41.5014 60.1851 38.9744 57.8804 36.8573C55.5757 34.7401 52.8436 33.0753 49.8441 31.9602C46.8445 30.8452 43.6378 30.3024 40.4116 30.3637C34.0647 30.4841 28.021 32.9323 23.5777 37.1828C19.1345 41.4332 16.6458 47.1472 16.6458 53.0983C16.6458 59.0494 19.1345 64.7634 23.5777 69.0138C28.021 73.2643 34.0647 75.7125 40.4116 75.8329ZM5.34118e-05 121.293C-0.0164364 111.78 3.78577 102.609 10.6511 95.603C17.5163 88.5971 26.9421 84.2691 37.0552 83.4789C47.1682 82.6888 57.2282 85.4944 65.2359 91.3383C73.2436 97.1822 78.6128 105.636 80.2765 115.021H131.544C133.521 115.021 135.418 115.757 136.816 117.068C138.214 118.379 139 120.157 139 122.01C139 123.864 138.214 125.642 136.816 126.953C135.418 128.264 133.521 129 131.544 129H7.65489C5.76726 129 3.95007 128.328 2.56998 127.121C1.18989 125.913 0.349639 124.26 0.218763 122.495C0.0793337 122.108 0.00880301 121.702 0.00999476 121.293H5.34118e-05Z"
                fill="#020C41"
              />
            </svg>
          </div>
          <h3 className="modal-text">
            ¿Ha finalizado la captura de todos su embarques?
          </h3>
          <div className="modal-buttons">
            <Button onClick={handleConfirm} className="confirm-button">
              Sí
            </Button>
            <Button
              onClick={() => {
                setStatusConfirmationModal(false);
                removeLastData();
              }}
              className="cancel-button"
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderSpinnerModal = () => {
    return (
      <Modal show={statusSpinnerModal} className="custom-modal">
        <Modal.Body className="text-center">
          <div className="custom-spinner">
            <div className="progress-circle"></div>
          </div>
          <p>Procesando turno</p>
        </Modal.Body>
      </Modal>
    );
  };

  const renderLabels = () => {
    return (
      <div className="div-1">
        <div id="label-content">
          {labelsArr.map((label, _index) => (
            <div className="amc-home-label page-break" key={_index}>
              <div className="amc-home-label-header">
                <h4>Identificador: {turn.turn_number}</h4>
                <div className="amc-logo">
                  <img src={amc_black_logo} alt="Aeromexico Cargo" />
                </div>
              </div>
              <div className="amc-home-label-body">
                <div className="amc-date">
                  <div className="info">
                    <span className="text-bold">
                      {" "}
                      Embarque: {shipmentNumber(_index)}
                    </span>
                  </div>
                  <div className="date">
                    <span className="text-bold">{currentDate}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="text-bold">{currentTime}</span>
                  </div>
                </div>
                <table className="amc-table">
                  <tbody>
                    <tr>
                      <td>Consignatario</td>
                      <td className="text-bold">
                        {label.shipment_name.toUpperCase()}
                      </td>
                    </tr>
                    <tr>
                      <td>Destino</td>
                      <td className="text-bold">
                        {label.destination.toUpperCase()}
                      </td>
                    </tr>
                    <tr>
                      <td>Tipo de carga</td>
                      <td className="text-bold">
                        {label?.merchandise_description
                          ? label?.merchandise_description.toUpperCase()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Piezas</td>
                      <td className="text-bold">{label.piece}</td>
                    </tr>
                  </tbody>
                </table>
                <p className="paste-text">Pegar en caja</p>
              </div>
            </div>
          ))}
          
          <div id="ticket-content" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <div className="amc-home-ticket">
              <div className="amc-home-ticket-header">
                <div className="amc-home-ticket-header-icon">
                  <img src={amc_black_logo} alt="logo amc" />
                </div>
                <div className="amc-home-ticket-header-hour">
                  <div className="amc-home-ticket-header-hour-date">
                    <p>{currentDate}</p>
                  </div>
                  <div className="amc-home-ticket-header-date">
                    <p>{currentTime}</p>
                  </div>
                </div>
              </div>
              <div className="amc-home-ticket-body">
                <h2>Turno</h2>
                <h2 className="text-bold" style={{marginTop: "-10px"}}>{turn.turn_number}</h2>
                <p>Cantidad de embarques</p>
                <h5 className="text-bold">{turn.total_shipment}</h5>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }

  const renderExitModal = () => {
    return (
      <Modal
        show={statusLabelsModal.status && statusLabelsModal.modal === "exit"}
        onHide={handleClose}
        className="custom-modal"
      >
        <Modal.Body className="text-center">
          <h3 className="modal-text">
            Por favor, pegue las etiquetas en cada pieza y coloque la carga en
            la banda de inspección.
          </h3>
          <Button onClick={handleClose} className="exit-button">
            Salir
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="light-clients-container">
        <Header />
        <div className="clients-body-container">
          <div className="clients-view-container">
            <h3>Captura</h3>
            <h5>
              Estimado cliente, ingrese los datos generales de cada uno de sus
              embarques
            </h5>
            <ClientsForm />
            <p className="text-separate">Ó</p>
            <button className="btn-emit-turn" onClick={handleSendData}>Emitir turno</button>
          </div>
          {/* <div className="clients-right">
          </div> */}
        </div>
      </div>
      {/* Confirmation Modal */}
      {renderConfirmationModal()}
      {/* Spinner Modal */}
      {renderSpinnerModal()}
      {/* Modal de Etiquetas */}
      {renderLabels()}
      {/* Modal de Ticket */}
      {renderExitModal()}
    </>
  );
}
export default ClientsMain;